import { render, staticRenderFns } from "./ProjectViewContractsReview.vue?vue&type=template&id=3f7849e4&"
import script from "./ProjectViewContractsReview.vue?vue&type=script&lang=js&"
export * from "./ProjectViewContractsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports